module.exports = __webpack_public_path__ + "media/categories/1058-66159700.svg";